import React from "react";

import Bar from "../Bar/Bar";
import Line from "../Line/Line";
import Pie from "../Pie/Pie";
import Donut from "../Donut/Donut";

const ChartSettings = ({ chartConfig, setChartConfig }) => {
  let body = (
    <div>
      <Bar setChartConfig={setChartConfig} bar={chartConfig?.plotOptions.bar} />
      <Line setChartConfig={setChartConfig} chartConfig={chartConfig} />
      <Pie setChartConfig={setChartConfig} chartConfig={chartConfig} />
      <Donut setChartConfig={setChartConfig} chartConfig={chartConfig} />
    </div>
  );

  return body;
};

export default ChartSettings;
